import React, { useEffect } from 'react';
import { HoverButton } from 'src/components';
import { FormState } from '../model';
import styled from 'styled-components/native';
import { Margin } from 'src/constants';
import { ChevronLeft } from 'react-native-feather';
import { useTranslation } from 'react-i18next';
import { useAppTheme } from 'src/providers/AppThemeProvider';
import { useNavigation } from '@react-navigation/native';

interface Props {
  state: FormState;
  formGoBack: () => void;
  formAdvance: () => void;
  dirty: boolean;
  hasContactMethod: boolean;
  name?: string;
  handleSubmit: () => void;
}
const useNavControl = ({
  state,
  formGoBack,
  formAdvance,
  handleSubmit,
  dirty,
  hasContactMethod,
  name
}: Props) => {
  const { t } = useTranslation('informationUpdate');
  const { colors, viewMode } = useAppTheme();
  const { setOptions } = useNavigation();

  useEffect(() => {
    if (state === FormState.EDIT_INFO) {
      setOptions({
        headerLeft: () => <BackButton onPress={formGoBack} />,
        title: t('editing', { name })
      });
    } else {
      setOptions({
        headerLeft: () => <BackButton onPress={formGoBack} />,
        title: t(`confirmYourChanges`)
      });
    }
  }, [
    colors.primary,
    colors.text,
    dirty,
    formAdvance,
    formGoBack,
    handleSubmit,
    hasContactMethod,
    name,
    setOptions,
    state,
    t,
    viewMode.isMobile
  ]);
};

export default useNavControl;

const BackButton = styled(HoverButton).attrs({
  icon: ChevronLeft,
  mode: 'contained'
})`
  padding: ${Margin.Small}px;
  border-radius: ${Margin.ExtraLarge}px;
  flex-shrink: 0;
  margin-left: ${Margin.Large}px;
  margin-vertical: ${Margin.Large}px;
`;
